import { darken } from 'utils/styles'

export const createTheme = (color) => `
  color: ${color};

  :visited {
    color: ${color};
  }

  :hover {
    color: ${darken(color, 20)};
  }
`
